import { render, staticRenderFns } from "./periode2.vue?vue&type=template&id=98d076fa&"
import script from "./periode2.vue?vue&type=script&lang=js&"
export * from "./periode2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports